var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-list-container" },
    [
      _c(
        "v-centerForm",
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: "",
                    model: _vm.searchForm,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入订单号", clearable: "" },
                        model: {
                          value: _vm.searchForm.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderNo", $$v)
                          },
                          expression: "searchForm.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "PNR", prop: "pnr" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入PNR", clearable: "" },
                        model: {
                          value: _vm.searchForm.pnr,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "pnr", $$v)
                          },
                          expression: "searchForm.pnr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "票号", prop: "ticketNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入票号", clearable: "" },
                        model: {
                          value: _vm.searchForm.ticketNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "ticketNo", $$v)
                          },
                          expression: "searchForm.ticketNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "出发地", prop: "depCity" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入出发地", clearable: "" },
                        model: {
                          value: _vm.searchForm.depCity,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "depCity", $$v)
                          },
                          expression: "searchForm.depCity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "目的地", prop: "arrCity" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入目的地", clearable: "" },
                        model: {
                          value: _vm.searchForm.arrCity,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "arrCity", $$v)
                          },
                          expression: "searchForm.arrCity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "去程起飞日期" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.searchForm.outboundDepDateRange,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "outboundDepDateRange",
                              $$v
                            )
                          },
                          expression: "searchForm.outboundDepDateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "乘客姓名", prop: "passengerName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入乘客姓名", clearable: "" },
                        model: {
                          value: _vm.searchForm.passengerName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "passengerName", $$v)
                          },
                          expression: "searchForm.passengerName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh-left" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-tabs",
        {
          staticClass: "order-tabs",
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部订单", name: "all" } }),
          _c("el-tab-pane", {
            attrs: { label: "未出票订单", name: "unticketed" },
          }),
          _c("el-tab-pane", {
            attrs: { label: "已出票订单", name: "ticketed" },
          }),
          _c("el-tab-pane", { attrs: { label: "问题订单", name: "problem" } }),
          _c("el-tab-pane", {
            attrs: { label: "取消订单", name: "cancelled" },
          }),
        ],
        1
      ),
      _c(
        "v-tableEncapsulation",
        {
          attrs: {
            loading: _vm.loadingBtn.tableLoading,
            columnData: _vm.columnData,
            tableSize: _vm.pagination.size,
            tableData: _vm.tableData,
            tableTotal: _vm.pagination.total,
            currentPage: _vm.pagination.current,
          },
          on: {
            currentPage: _vm.handleCurrentChange,
            sizeChange: _vm.handleSizeChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              slot: "tripType",
              label: "行程类型",
              align: "center",
              width: "100px",
            },
            slot: "tripType",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getTripTypeText(scope.row.tripType)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              slot: "orderStatus",
              label: "系统订单状态",
              align: "center",
              width: "150px",
            },
            slot: "orderStatus",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getStatusTagType(scope.row.orderStatus),
                          effect: "dark",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getStatusText(scope.row.orderStatus)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              slot: "operate",
              label: "操作",
              align: "center",
              width: "200px",
              fixed: "right",
            },
            slot: "operate",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("详单")]
                    ),
                    _vm.hasPermission("order:updateStatus")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.updateStatus(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 修改订单状态 ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }